import { useEffect, useRef } from 'react';

// like useEffect but runs only on rerenders (not initially)
export default function useUpdateEffect(handler, dependencies) {
  const didMount = useRef(false);
  useEffect(() => {
    if (didMount.current) {
      handler();
    } else {
      didMount.current = true;
    }
  }, dependencies); // eslint-disable-line
}
